import React from "react";
import { Link } from "react-router-dom";
import "./auth-visual.css";

const stories = {
  login: {
    label: "Your account, in view",
    headline: "A considered space for your next move.",
    body: "Come back to the tools and information you use to navigate digital-asset markets.",
  },
  register: {
    label: "Start with perspective",
    headline: "Make room for a clearer view.",
    body: "Create an account to explore the ProfitGrowing platform and its available tools.",
  },
  recovery: {
    label: "Account support",
    headline: "A simple way back in.",
    body: "Use the email address connected to your account and follow the reset instructions we send.",
  },
  reset: {
    label: "Account support",
    headline: "Choose a fresh password.",
    body: "Set a password you do not use elsewhere, then sign in to continue.",
  },
};

function AuthBrand() {
  return (
    <span className="auth-brand-lockup">
      <span className="auth-brand-mark" aria-hidden="true">
        <svg viewBox="0 0 32 32" fill="none">
          <path d="m6 22 7-7 5 4 8-10" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M20 9h6v6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      <span className="auth-brand-name">Profit<span>Growing</span></span>
    </span>
  );
}

export default function AuthShell({ variant, title, description, children, footer }) {
  const story = stories[variant] || stories.login;

  return (
    <main className={"auth-shell auth-shell--" + variant}>
      <header className="auth-header">
        <Link className="auth-brand" to="/" aria-label="ProfitGrowing home">
          <AuthBrand />
        </Link>
        <Link className="auth-home-link" to="/">
          <span>Back to home</span>
          <svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M4 10h11M10 5l5 5-5 5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" /></svg>
        </Link>
      </header>

      <div className="auth-main">
        <aside className="auth-story">
          <div className="auth-story-copy">
            <span className="auth-overline"><i />{story.label}</span>
            <h1>{story.headline}</h1>
            <p>{story.body}</p>
          </div>
          <div className="auth-story-art" aria-hidden="true">
            <div className="auth-art-orbit auth-art-orbit--outer" />
            <div className="auth-art-orbit auth-art-orbit--inner" />
            <div className="auth-art-card">
              <div className="auth-art-card-top"><span>Market overview</span><span className="auth-art-status"><i /> Platform preview</span></div>
              <svg viewBox="0 0 420 140" role="presentation">
                <path className="auth-art-gridline" d="M0 28h420M0 70h420M0 112h420" />
                <path className="auth-art-area" d="M0 112c28-7 31 4 60-9s43 4 69-8 37 8 65-6 39-1 64-18 47 9 72-8 48 0 62-22 25-6 28-16v115H0Z" />
                <path className="auth-art-line" d="M0 112c28-7 31 4 60-9s43 4 69-8 37 8 65-6 39-1 64-18 47 9 72-8 48 0 62-22 25-6 28-16" />
              </svg>
              <div className="auth-art-card-foot"><span>Explore at your own pace</span><span>Digital assets involve risk</span></div>
            </div>
          </div>
          <p className="auth-story-note">Information and tools for exploring markets. No outcome is guaranteed.</p>
        </aside>

        <section className="auth-card" aria-label={title}>
          <div className="auth-card-heading">
            <span className="auth-card-kicker">ProfitGrowing account</span>
            <h2>{title}</h2>
            <p>{description}</p>
          </div>
          {children}
          {footer ? <div className="auth-card-footer">{footer}</div> : null}
        </section>
      </div>

      <footer className="auth-page-footer">
        <span>Digital assets can be volatile and may lose value.</span>
        <span><Link to="/privacy">Privacy</Link><i /> <Link to="/terms">Terms</Link></span>
      </footer>
    </main>
  );
}
